var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenmessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8418 2.87307C9.12343 2.86155 9.36953 2.94944 9.58008 3.13674C11.4317 4.47268 13.2832 5.80862 15.1348 7.14456C15.3468 7.27442 15.4933 7.45608 15.5742 7.68948C15.5977 10.1856 15.5977 12.6817 15.5742 15.1778C13.9232 13.4921 12.2885 11.7928 10.6699 10.0801C11.6895 9.33011 12.709 8.58009 13.7285 7.8301C12.1554 6.67856 10.5734 5.54185 8.98242 4.41995C7.38654 5.5409 5.80451 6.68348 4.23633 7.84768C5.26163 8.58614 6.28116 9.33029 7.29492 10.0801C5.65376 11.774 4.01899 13.4732 2.39063 15.1778C2.36719 12.67 2.36719 10.1621 2.39063 7.65432C2.42046 7.54189 2.47319 7.44229 2.54883 7.35549C4.55084 5.92769 6.54304 4.48629 8.52539 3.03127C8.62865 2.96796 8.73411 2.91523 8.8418 2.87307Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31445 10.8535C8.55366 10.963 8.7763 11.1036 8.98242 11.2754C9.17483 11.1474 9.36232 11.0127 9.54492 10.8711C9.58008 10.8477 9.61523 10.8477 9.65039 10.8711C11.308 12.6049 12.9721 14.3335 14.6426 16.0566C10.8692 16.1035 7.09569 16.1035 3.32227 16.0566C4.99989 14.3322 6.66394 12.5978 8.31445 10.8535Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenmessage);
export default __webpack_public_path__ + "static/media/openmessage.6e0c34afabbb80b15f26dee29a967c85.svg";
export { ForwardRef as ReactComponent };